export const PURCHASES_LOCKED = true;

export const REBRAND_ANNOUNCEMENT =
  'SweatDNS is no longer continuing due to rebranding our software. It will be available on the new rebranded software. New purchases are closed.';

export const PURCHASES_LOCKED_MESSAGE =
  'New purchases and trials are closed. SweatDNS is no longer continuing due to rebranding our software, and will be available on the new rebranded software.';
